import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import JsonEditorBase from "./JsonEditorBase";
interface FilterInputProps {
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

// Validate filter DSL structure
function validateFilterDSL(jsonString: string): {
  valid: boolean;
  error?: string;
} {
  try {
    const parsed = JSON.parse(jsonString);

    // Check if top level has $and or $or
    if (!parsed.$and && !parsed.$or) {
      return {
        valid: false,
        error: "Top level must contain $and or $or"
      };
    }

    // Valid operators
    const validOperators = ["$eq", "$ne", "$gt", "$gte", "$lt", "$lte", "$in", "$nin"];

    // Recursively check structure
    const checkConditions = (conditions: any): boolean => {
      if (!Array.isArray(conditions)) return false;
      return conditions.every(condition => {
        // Check if it's a nested $and/$or
        if (condition.$and || condition.$or) {
          return checkConditions(condition.$and || condition.$or);
        }

        // Check if it has a field with valid operator
        const keys = Object.keys(condition);
        return keys.some(key => {
          if (typeof condition[key] === "object") {
            return Object.keys(condition[key]).some(op => validOperators.includes(op));
          }
          return false;
        });
      });
    };
    const conditions = parsed.$and || parsed.$or;
    if (!checkConditions(conditions)) {
      return {
        valid: false,
        error: "Invalid filter condition structure"
      };
    }
    return {
      valid: true
    };
  } catch (e) {
    return {
      valid: false,
      error: e instanceof Error ? e.message : "Invalid JSON"
    };
  }
}
export default function FilterInput(t0) {
  const $ = _c(11);
  const {
    label,
    description,
    value,
    onChange,
    placeholder
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      valid: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [validation, setValidation] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== value) {
    t2 = () => {
      if (value && value.trim() !== "") {
        setValidation(validateFilterDSL(value));
      } else {
        setValidation({
          valid: true
        });
      }
    };
    t3 = [value];
    $[1] = value;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const t4 = placeholder || "{ \"$and\": [] }";
  let t5;
  if ($[4] !== description || $[5] !== label || $[6] !== onChange || $[7] !== t4 || $[8] !== validation || $[9] !== value) {
    t5 = <JsonEditorBase label={label} description={description} value={value} onChange={onChange} placeholder={t4} validation={validation} showValidationInline={true} customValidate={validateFilterDSL} />;
    $[4] = description;
    $[5] = label;
    $[6] = onChange;
    $[7] = t4;
    $[8] = validation;
    $[9] = value;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}